<template>
  <article class="BlogCArd">
    <router-link
      :to="{
        name: 'blogDetail',
        params: { id: blog.id, slug: blog.slug },
      }"
    >
      <div class="article-img">
        <img
          decoding="async"
          loading="lazy"
          v-if="blog.image"
          :src="blog.image.url"
          :alt="blog.title"
        />
        <img
          loading="lazy"
          decoding="async"
          v-else
          src="../../../assets/images/blog.jpg"
          alt="blog"
        />
      </div>
      <div class="text-right article-title">
        <div class="blogCategory">
          <router-link
            :to="`/weblog-list/${blog.category.id}/${blog.category.slug}`"
          >
            {{ blog.category.name }}
          </router-link>
        </div>
        <h6 class="d-inline-block fontsize-small weight-bold text-color-444 ">
          <!-- <svg
                  class="mt-n1"
                  width="15"
                  height="15"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7.36922 10.869C7.42572 10.811 7.63906 10.563 7.8378 10.359C9.00292 9.076 12.0424 6.976 13.6332 6.335C13.8748 6.232 14.4856 6.014 14.812 6C15.1247 6 15.4228 6.072 15.7073 6.218C16.0619 6.422 16.3463 6.743 16.5022 7.122C16.6025 7.385 16.7584 8.172 16.7584 8.186C16.9143 9.047 17 10.446 17 11.992C17 13.465 16.9143 14.807 16.7867 15.681C16.772 15.695 16.6162 16.673 16.4457 17.008C16.133 17.62 15.5222 18 14.8685 18H14.812C14.3863 17.985 13.491 17.605 13.491 17.591C11.9859 16.949 9.01656 14.952 7.82319 13.625C7.82319 13.625 7.48709 13.284 7.34096 13.071C7.11301 12.765 7 12.386 7 12.007C7 11.584 7.12762 11.19 7.36922 10.869Z"
                    fill="#444"
                  />
                </svg> -->
          {{ blog.title }}
        </h6>
        <!-- <p class="blogSummary">
                {{
                  blog.summary
                    ? blog.summary.length > 150
                      ? blog.summary.slice(0, 150) + "..."
                      : blog.summary
                    : ""
                }}
              </p> -->
        <div v-if="blog.created_at" class="date-created-at">
          <span>تاریخ انتشار:</span>
          <time :datetime="blog.created_at">
            {{ moment(blog.created_at).format("YYYY/MM/DD") }}</time
          >
        </div>
      </div>
    </router-link>
  </article>
</template>
<script>
export default {
  props: {
    blog: Object,
  },

  //   mounted() {

  //     // get height of articles/
  //     let bodyWidth = document.body.offsetWidth;
  //     const articleImg = document.querySelectorAll(".article-img");
  //     if (bodyWidth < 767) {
  //       for (let iImg of articleImg) {
  //         let imgH = iImg.offsetWidth / 1.45;
  //         iImg.style.height = imgH + "px";
  //       }
  //     }

  //     window.addEventListener("resize", function() {
  //       // get height of articles/
  //       // let bodyWidth=document.body.offsetWidth;
  //       const articleImg = document.querySelectorAll(".article-img");
  //       for (let iImg of articleImg) {
  //         let imgH = iImg.offsetWidth / 1.45;
  //         iImg.style.height = imgH + "px";
  //       }
  //     });
  //   },
};
</script>
<style scoped>
.article-title {
  padding: 6px;
  padding-top: 10px;
}

.article-title h6 {
  padding-block: 6px;
  max-width: 95%;
  height: 26px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  font-weight: 800;
  font-size: 16px;
  margin: auto;
}

.blogCategory a {
  padding: 6px 20px;
  /* color: gray;
  background-color: rgb(210 239 154);*/
  background-color: var(--newTheme-color);
  color: white;
  font-size: 13px;
  border-radius: 50px;
}

.blogCategory {
  margin: 8px auto;
  color: black;
  display: flex;
  gap: 8px;
}

p.blogSummary,
.date-created-at {
  color: #00000080;
  font-size: 14px;
  margin-bottom: 10px;
}

.article-img {
  overflow: hidden;
  position: relative;
  height: auto !important;
}

.article-img img {
  width: 100%;
  transition: all 0.5s;
}

.article-img {
  width: 100%;
  overflow: hidden;
  position: relative;
}

.article-img img {
  width: 100%;
  /*object-fit: fill;*/
}

.article-img-hover {
  height: 75%;
  position: absolute;
  right: 0;
  left: 0;
  bottom: 0;
  background-image: linear-gradient(to top, var(--color-theme), #12131400);
  transform: scaleY(0);
  transform-origin: bottom;
}

.BlogCArd {
  border: 1px solid var(--color-da);
  border-radius: 12px;
  overflow: hidden;
  background-color: white;
}

.BlogCArd:hover .article-img img {
  transform: scale(1.2);
}

@media screen and (max-width: 1199px) {
  .article-img {
    /* width: 100%; */
  }
}

@media screen and (max-width: 991px) {
  .article-img {
    /* width: 100%; 
    height: 110px;*/
  }
}

@media screen and (max-width: 600px) {
  .article-title h6 {
    max-width: 98%;
  }

  .blogCategory a {
    padding: 4px 10px;

    font-size: 12px;
  }
}
</style>
